export function walkTree(cursor, visit) {
    const hasChild = cursor.firstChild();
    if (hasChild) {
        do {
            walkTree(cursor, visit);
        } while (cursor.nextSibling());
        cursor.parent();
        return;
    }
    visit();
}
